@if (!pdfMode) {
    <div
        fxLayout="column"
        class="report-performance gap-16 padding-12"
        [class.device-desktop]="!isMobile()"
        [class.device-mobile]="isMobile()"
        [class.preview-mode]="previewMode"
        [class.chat-nanda-open]="chatNandaIsOpen()"
    >
        <div>
            <app-chart-performance-report
                [results]="resultDataSignal()"
                [currentTab]="currentTabSignal()"
            ></app-chart-performance-report>
        </div>
        <p class="color-text-primary text-14-regular">
            Veja a performance da sua empresa comparado com:
        </p>
        <div
            style="gap: 16px"
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <dsn-tabs [size]="'medium'">
                @for (tab of tabsSignal(); track $index) {
                    <dsn-tab
                        [active]="currentTabSignal() === tab.value"
                        (click)="onChangeTab(tab.value)"
                        >{{ tab.label }}
                    </dsn-tab>
                }
            </dsn-tabs>
            @if (!isMobile()) {
                <p
                    class="text-12-semi-bold color-text-primary cursor-pointer"
                    matTooltip="Os valores de referência provêm de pesquisas acadêmicas, estudos, consultorias e prática de mercado, baseados em amostras de empresas de diversos setores e tamanhos."
                    (click)="onOpenHelpCenter()"
                >
                    <i
                        class="fa-solid fa-circle-info"
                        style="margin-right: var(--spacing-4)"
                    ></i>
                    Entenda os valores de referência
                </p>
            }
        </div>
        <div [hidden]="currentTabSignal() !== 'reference'">
            <div class="gap-12">
                @if (isMobile()) {
                    <p
                        class="text-12-regular color-text-primary cursor-pointer"
                        (click)="openInfoDialog()"
                    >
                        <i
                            class="fa-solid fa-circle-info"
                            style="margin-right: var(--spacing-4)"
                        ></i>
                        Entenda os valores de referência
                    </p>
                }
                @for (result of resultsReferencesSignal(); track $index) {
                    <dsn-expand-collapse
                        [isExpanded]="$index === 0"
                        [icon]="result.icon"
                        [label]="result.label"
                        [labelHint]="result.labelHint"
                        [colorCustom]="result.color"
                        [type]="'default'"
                        [horizontalPadding]="false"
                        customIconSize="small"
                        [fontSize]="isMobile() ? 'small' : 'medium'"
                    >
                        <div
                            class="gap-12 report-performance_cards"
                            [class.is-mobile]="isMobile()"
                            style="margin: var(--spacing-8) 0"
                            fxLayout="row wrap"
                        >
                            @for (serie of result.series; track $index) {
                                <div
                                    class="report-performance_card"
                                    [class.report-performance_card--mobile]="
                                        isMobile()
                                    "
                                >
                                    <app-card-indicator-performance
                                        [type]="result.typeColor"
                                        [withTheme]="true"
                                        [title]="serie.name"
                                        [titleHint]="report?.isMultiSource && `${serie.source}`"
                                        [month]="serie.month"
                                        [monthValue]="serie.monthValue"
                                        [monthPercentageValue]="
                                            serie.monthPercentageValue
                                        "
                                        [referenceLabel]="'Valor de referência'"
                                        [referenceValue]="serie.referenceValue"
                                        [variation]="serie.variation"
                                        [progressOptions]="{
                                            mark: serie.referenceInterval,
                                            value: serie.associatedValue,
                                            customColor: result.progressColor,
                                            range: {
                                                min: serie.progressRange.min,
                                                max: serie.progressRange.max
                                            }
                                        }"
                                        [footerLabel]="serie.resultLabel"
                                        [operator]="serie.operator"
                                        [direction]="serie.direction"
                                        [polarity]="serie.polarity"
                                        [info]="serie.info"
                                        (handleClickInfo)="onClickInfo(serie)"
                                    ></app-card-indicator-performance>
                                </div>
                            }
                        </div>
                    </dsn-expand-collapse>
                }
            </div>
        </div>
        <div [hidden]="currentTabSignal() !== 'comparison'">
            <div class="gap-12">
                @for (result of resultsComparationsSignal(); track $index) {
                    <dsn-expand-collapse
                        [isExpanded]="$index === 0"
                        [horizontalPadding]="false"
                        [icon]="result.icon"
                        [label]="result.label"
                        [labelHint]="result.labelHint"
                        [colorCustom]="result.color"
                        [type]="'default'"
                        [horizontalPadding]="false"
                        [fontSize]="isMobile() ? 'small' : 'medium'"
                        customIconSize="small"
                    >
                        <div
                            class="gap-12 report-performance_cards"
                            [class.is-mobile]="isMobile()"
                            style="margin: var(--spacing-8) 0"
                            fxLayout="row wrap"
                        >
                            @for (serie of result.series; track $index) {
                                <div
                                    class="report-performance_card"
                                    [class.report-performance_card--mobile]="
                                        isMobile()
                                    "
                                >
                                    <app-card-indicator-performance
                                        [type]="result.typeColor"
                                        [withTheme]="true"
                                        [title]="serie.name"
                                        [titleHint]="report?.isMultiSource && `${serie.source}`"
                                        [month]="serie.month"
                                        [monthValue]="serie.monthValue"
                                        [referenceValue]="serie.referenceValue"
                                        [referenceLabel]="serie.referenceLabel"
                                        [variation]="serie.variation"
                                        [direction]="serie.direction"
                                        [polarity]="serie.polarity"
                                    ></app-card-indicator-performance>
                                </div>
                            }
                        </div>
                    </dsn-expand-collapse>
                }
            </div>
        </div>
        <div [hidden]="currentTabSignal() !== 'budget'">
            <div class="gap-12">
                @if (isMobile()) {
                    <p
                        class="text-12-regular color-text-primary cursor-pointer"
                        (click)="openInfoDialog()"
                    >
                        <i
                            class="fa-solid fa-circle-info"
                            style="margin-right: var(--spacing-4)"
                        ></i>
                        Entenda os valores de referência
                    </p>
                }
                @for (result of resultsBudgetSignal(); track $index) {
                    <dsn-expand-collapse
                        [isExpanded]="$index === 0"
                        [icon]="result.icon"
                        [label]="result.label"
                        [labelHint]="result.labelHint"
                        [colorCustom]="result.color"
                        [type]="'default'"
                        [horizontalPadding]="false"
                        customIconSize="small"
                    >
                        <div
                            class="gap-12 report-performance_cards"
                            [class.is-mobile]="isMobile()"
                            style="margin: var(--spacing-8) 0"
                            fxLayout="row wrap"
                        >
                            @for (serie of result.series; track $index) {
                                <div
                                    class="report-performance_card"
                                    [class.report-performance_card--mobile]="
                                        isMobile()
                                    "
                                >
                                    <app-card-indicator-performance
                                        [type]="result.typeColor"
                                        [withTheme]="true"
                                        [title]="serie.name"
                                        [titleHint]="report?.isMultiSource && `${serie.source}`"
                                        [month]="serie.month"
                                        [monthValue]="serie.monthValue"
                                        [monthPercentageValue]="
                                            serie.monthPercentageValue
                                        "
                                        [referenceLabel]="'Valor de referência'"
                                        [referenceValue]="serie.referenceValue"
                                        [variation]="serie.variation"
                                        [progressOptions]="{
                                            mark: serie.referenceInterval,
                                            value: serie.associatedValue,
                                            customColor: result.progressColor,
                                            range: {
                                                min: serie.progressRange.min,
                                                max: serie.progressRange.max
                                            }
                                        }"
                                        [footerLabel]="serie.resultLabel"
                                        [operator]="serie.operator"
                                        [direction]="serie.direction"
                                        [polarity]="serie.polarity"
                                        [info]="serie.info"
                                        (handleClickInfo)="onClickInfo(serie)"
                                    ></app-card-indicator-performance>
                                </div>
                            }
                        </div>
                    </dsn-expand-collapse>
                }
            </div>
        </div>
        <div [hidden]="currentTabSignal() !== 'goals'">
            <div class="gap-12">
                @for (result of resultsGoalsSignal(); track $index) {
                    <dsn-expand-collapse
                        [isExpanded]="$index === 0"
                        [icon]="result.icon"
                        [label]="result.label"
                        [labelHint]="result.labelHint"
                        [colorCustom]="result.color"
                        [type]="'default'"
                        [horizontalPadding]="false"
                        customIconSize="small"
                        [fontSize]="isMobile() ? 'small' : 'medium'"
                    >
                        <div
                            class="gap-12 report-performance_cards"
                            [class.is-mobile]="isMobile()"
                            style="margin: var(--spacing-8) 0"
                            fxLayout="row wrap"
                        >
                            @for (serie of result.series; track $index) {
                                <div
                                    class="report-performance_card"
                                    [class.report-performance_card--mobile]="
                                        isMobile()
                                    "
                                >
                                    <app-card-indicator-performance
                                        [type]="result.typeColor"
                                        [withTheme]="true"
                                        [title]="serie.name"
                                        [titleHint]="report?.isMultiSource && `${serie.source}`"
                                        [month]="serie.month"
                                        [monthValue]="serie.monthValue"
                                        [monthPercentageValue]="
                                            serie.monthPercentageValue
                                        "
                                        [referenceLabel]="'Objetivo'"
                                        [referenceValue]="serie.referenceValue"
                                        [variation]="serie.variation"
                                        [progressOptions]="{
                                            mark: serie.referenceInterval,
                                            value: serie.associatedValue,
                                            customColor: result.progressColor,
                                            range: {
                                                min: serie.progressRange.min,
                                                max: serie.progressRange.max
                                            }
                                        }"
                                        [footerLabel]="serie.resultLabel"
                                        [operator]="serie.operator"
                                        [direction]="serie.direction"
                                        [polarity]="serie.polarity"
                                        [info]="serie.info"
                                        (handleClickInfo)="onClickInfo(serie)"
                                    ></app-card-indicator-performance>
                                </div>
                            }
                        </div>
                    </dsn-expand-collapse>
                }
            </div>
        </div>
    </div>
} @else {
    <div
        fxLayout="column"
        style="padding: 0 var(--spacing-16) var(--spacing-16) var(--spacing-16)"
        class="gap-8"
    >
        <p class="text-10-semi-bold color-text-primary">
            Desempenho da sua empresa comparado com:
        </p>
        <div
            class="gap-8 pdf-performance-container"
            fxLayout="row"
            fxLayoutAlign="start start"
        >
            <div class="card-pdf-performance" fxLayout="column" fxFlex>
                <p class="text-10-semi-bold color-text-primary">
                    Valores de referência
                </p>
                <app-chart-performance-report
                    [results]="resultsReferencesSignal()"
                    [currentTab]="'reference'"
                    [pdf]="true"
                ></app-chart-performance-report>
            </div>
            <div class="card-pdf-performance" fxLayout="column" fxFlex>
                <p class="text-10-semi-bold color-text-primary">
                    {{ comparationLabel() }}
                </p>
                <app-chart-performance-report
                    [results]="resultsComparationsSignal()"
                    [currentTab]="'comparison'"
                    [pdf]="true"
                ></app-chart-performance-report>
            </div>
            @if (optionsSignal()?.budget) {
                <div class="card-pdf-performance" fxLayout="column" fxFlex>
                    <p class="text-10-semi-bold color-text-primary">
                        Orçamento
                    </p>
                    <app-chart-performance-report
                        [results]="resultsBudgetSignal()"
                        [currentTab]="'budget'"
                        [pdf]="true"
                    ></app-chart-performance-report>
                </div>
            }
            @if (optionsSignal()?.goals) {
                <div class="card-pdf-performance" fxLayout="column" fxFlex>
                    <p class="text-10-semi-bold color-text-primary">
                        Objetivos
                    </p>
                    <app-chart-performance-report
                        [results]="resultsGoalsSignal()"
                        [currentTab]="'goals'"
                        [pdf]="true"
                    ></app-chart-performance-report>
                </div>
            }
        </div>
    </div>
    <div fxLayout="row" style="margin-left: 18px; padding-bottom: 16px">
        <dsn-button-link
            [label]="'Veja a performance de cada indicador no Dash digital'"
            [type]="'default'"
            [icons]="['', 'fa-solid fa-external-link-alt']"
            [href]="linkDigital"
        ></dsn-button-link>
    </div>
}
